import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { PROD_WEB_URL } from "../utils/api.js" ;

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  let activeuser =localStorage.getItem('activeUser');
  activeuser =  JSON.parse(activeuser);
  console.log("activeUser", activeuser.user_type);
  
  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>

          <Link to={"/"+activeuser.user_type+"/dashboard"} className='sidebar-logo'>
            <img
              src={PROD_WEB_URL+'assets/images/logo.png'}
              alt='site logo'
              className='light-logo'
            />
            <img
              src={PROD_WEB_URL+'assets/images/logo-light.png'}
              alt='site logo'
              className='dark-logo'
            />
            <img
              src={PROD_WEB_URL+'assets/images/logo-icon.png'}
              alt='site logo'
              className='logo-icon'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            <li className=''>
              <NavLink  to={"/"+activeuser.user_type+"/dashboard"} className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon
                  icon='solar:home-smile-angle-outline'
                  className='menu-icon'
                />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li className=''>
              <NavLink  to={"/"+activeuser.user_type+"/profile"} className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon
                  icon='fluent:people-20-filled'
                  className='menu-icon'
                />
                <span>Profile</span>
              </NavLink>
            </li>

            {(activeuser.user_type == "staff") &&   <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='fluent:people-20-filled'
                  className='menu-icon'
                />
                <span>Customer</span>
              </Link>
              <ul className='sidebar-submenu'>
              {/*<li>
                  <NavLink
                    to={"/"+activeuser.user_type+'/customer-add'}
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Add Customer 
                  </NavLink>
                </li>*/}
                <li>
                  <NavLink
                    to={"/"+activeuser.user_type+'/customer'}
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Customers
                  </NavLink>
                </li>
              </ul>
            </li>} 

{(activeuser.user_type == "admin" || activeuser.user_type == "subadmin") && 
            <><li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='gridicons:multiple-users'
                  className='menu-icon'
                />
                <span>Staff</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/staff-add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Add Staff 
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/staff'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Staff
                  </NavLink>
                </li>
              </ul>
            </li>
 

            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='fluent:people-20-filled'
                  className='menu-icon'
                />
                <span>Customer</span>
              </Link>
              <ul className='sidebar-submenu'>
                {/*<li>
                  <NavLink
                    to='/admin/customer-add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Add Customer 
                  </NavLink>
                </li>*/}
                <li>
                  <NavLink
                    to='/admin/customer'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Customers
                  </NavLink>
                </li>
              </ul>
            </li></>}


            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='fluent:people-20-filled'
                  className='menu-icon'
                />
                <span>Bookings</span>
              </Link>
              <ul className='sidebar-submenu'>

              <li>
                  <NavLink
                    to={"/"+activeuser.user_type+'/enroll-order'}
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Enroll New Order
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/"+activeuser.user_type+'/orders'}
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Orders List
                  </NavLink>
                </li>
                 
              </ul>
            </li>


            {(activeuser.user_type == "admin") && <>
            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='material-symbols:map-outline'
                  className='menu-icon'
                />
                <span>Service</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/service-add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Add Service 
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/service'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Services
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='solar:camera-outline'
                  className='menu-icon'
                />
                <span>Work Gallery</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/work-gallery-add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Add Work Gallery 
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/work-gallery-list'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                  Work Galleries
                  </NavLink>
                </li>
              </ul>
            </li>


            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='solar:camera-outline'
                  className='menu-icon'
                />
                <span>Gallery</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/gallery-add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                   Add Gallery
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/gallery'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                    Galleries
                  </NavLink>
                </li>
              </ul>
            </li>

            {(activeuser.user_type == "admin") &&   <li className=''>
              <NavLink  to={"/"+activeuser.user_type+"/settings"} className={(navData) => (navData.isActive ? "active-page" : "")}>
                <Icon
                  icon='fluent:people-20-filled'
                  className='menu-icon'
                />
                <span>Loyalty Program</span>
              </NavLink>
            </li>}

       
            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='fe:vector'
                  className='menu-icon'
                />
                <span>Blog</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/blog-add'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                   Add Blog 
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/blog'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                   Blogs
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='solar:document-text-outline'
                  className='menu-icon'
                />
                <span>Content Management</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/add-content'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                   Add Content 
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/content-management'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                     Manage Content
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className='dropdown'>
              <Link to='#'>
                <Icon
                  icon='hugeicons:money-send-square'
                  className='menu-icon'
                />
                <span>Price Management</span>
              </Link>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink
                    to='/admin/add-price'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    Add Prices
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/price-management'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                     Manage Prices
                  </NavLink>
                </li>
              </ul>
            </li>


            <li>
              <NavLink
                to='/admin/enquiry'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='flowbite:users-group-outline' className='menu-icon' />
                <span>Enquiry</span>
              </NavLink>
            </li>
            </>
}
           

            <li>
              <NavLink
                to='/logout'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='lucide:power' className='menu-icon' />
                <span> Log Out</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
                
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
               
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <img
                     src={(activeuser.image != "")? process.env.REACT_APP_BASE_URL+activeuser.image:"https://media.glamour.com/photos/5a425fd3b6bcee68da9f86f8/master/pass/best-face-oil.png"}
                       alt='image_user'
                      className='w-40-px h-40-px object-fit-cover rounded-circle'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                         {activeuser.name}
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                        {activeuser.user_type}
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      {/* <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/view-profile'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />{" "}
                          My Profile
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='/logout'
                        >
                          <Icon icon='lucide:power' className='icon text-xl' />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>
        
        {/* Footer section */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© <script>document.write(new Date().getFullYear());</script> Brow Smart. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <p className='mb-0'>
                Made by <span className='text-primary-600'>Li Square Tech Pvt Ltd</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
